import Link from 'next/link';
import styled from 'styled-components';
import { inlineLink, theme } from '@frameio/vapor';

export const StyledLink = styled(Link)`
  ${inlineLink}
  color: ${theme.colors.text.tertiary};
  font-weight: ${theme.fontWeights.semiBold};
`;

export const StyledA = styled.a`
  ${inlineLink}
  color: ${theme.colors.text.tertiary};
  font-weight: ${theme.fontWeights.semiBold};
`;
